import React, { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const [items, setItems] = useState([]);   // [{equipment, qty}]
    const [open, setOpen]   = useState(false); // cart drawer open

    const addItem = useCallback((equipment) => {
        setItems(prev => {
            const existing = prev.find(i => i.equipment.id === equipment.id);
            if (existing) {
                return prev.map(i =>
                    i.equipment.id === equipment.id
                        ? { ...i, qty: i.qty + 1 }
                        : i
                );
            }
            return [...prev, { equipment, qty: 1 }];
        });
        setOpen(true);
    }, []);

    const removeItem = useCallback((id) => {
        setItems(prev => prev.filter(i => i.equipment.id !== id));
    }, []);

    const updateQty = useCallback((id, qty) => {
        if (qty < 0) { removeItem(id); return; }
        setItems(prev => prev.map(i =>
            i.equipment.id === id ? { ...i, qty } : i
        ));
    }, [removeItem]);

    const clearCart = useCallback(() => setItems([]), []);

    const total = items.reduce((sum, i) => sum + (i.equipment.rental_price_day || 0) * i.qty, 0);
    const count = items.reduce((sum, i) => sum + i.qty, 0);

    return (
        <CartContext.Provider value={{ items, count, total, open, setOpen, addItem, removeItem, updateQty, clearCart }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used inside CartProvider");
    return ctx;
}
